'use strict';
var $ = jQuery;

(function ($) {

    //data-masonry='{ "itemSelector": ".gallery-img", "columnWidth": ".gallery-img"}'

    /*
    $('.masonry.hjr-gallery').masonry({
      // options
      itemSelector: '.gallery-img',
      columnWidth:  '.gallery-img'
    });
    */

    // init Masonry
    var $grid = $('.masonry.hjr-gallery').masonry({
      // options
      itemSelector: '.gallery-img',
      columnWidth:  '.gallery-img'
    });


    // layout Masonry after each image loads
    $grid.imagesLoaded().progress( function() {
       $grid.masonry('layout');
    });

    // init Masonry
    var $werk_grid = $('.werk-grid').masonry({
      // options
      itemSelector: '.werk',
      columnWidth:  '.werk'
    });


    // layout Masonry after each image loads
    $werk_grid.imagesLoaded().progress( function() {
       $werk_grid.masonry('layout');
    });

   
})(jQuery);
